import React, { Component } from 'react';
import './Checkbox.module.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export class Checkbox extends Component {

    constructor() {
        super();

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        e.stopPropagation();
        this.props.handleClick();
    }

    render() {
        const { label, dark, checked, style, hoverCheck } = this.props;
        return (
            <div styleName={`checkbox-background ${dark ? 'dark' : ''} ${hoverCheck ? 'hoverCheck' : ''}`} style={style} onClick={this.handleClick}>
                <FontAwesomeIcon styleName='icon' icon={checked ? [ 'fas', 'check-square' ] : [ 'far', 'square' ]}/>
                <p>{label}</p>
            </div>
        );
    }
}

export default Checkbox;